import { render, staticRenderFns } from "./cash.vue?vue&type=template&id=6e28fc70&scoped=true&"
import script from "./cash.vue?vue&type=script&lang=js&"
export * from "./cash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e28fc70",
  null
  
)

export default component.exports